module.exports = __webpack_public_path__ + "static/media/proj4_img6.f4451c7a.jpg";